var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 1366",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m683,83c-6.94,0-13.81.29-20.69.52,7.96,134.54,25.18,245.82,112.82,333.46,125.72,125.72,318.23,137.27,471.43,59.64-84.14-229.7-304.71-393.62-563.56-393.62Zm240.32,344.24c-53.95,0-97.68-43.73-97.68-97.68s43.73-97.68,97.68-97.68,97.68,43.73,97.68,97.68-43.74,97.68-97.68,97.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m83,683c0,220.59,119.12,413.26,296.47,517.5,1.7-2.03,257.44-307.83,277.37-527.13,20-220.03-1.66-263.85-67.19-410.96-62.06-139.32-87.54-150.18-89.7-150.88C258.12,188.94,83,415.48,83,683Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1283,683c0-14.87-1.29-35.94-2.35-50.54-265.61-60.03-453.56-116.7-509.15,50.54-59.8,179.87-6.74,294.63,185.36,533.8,193.6-99.53,326.14-301.12,326.14-533.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m683,1283c42.17,0,83.31-4.4,123.03-12.68-.39-197.96-61.01-358.13-135.76-358.13s-132.84,243.69-135.64,352.28c47.46,12.08,97.16,18.53,148.37,18.53Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e8170f0e883fd62dfe94e370c7e3e542.svg";
export { ForwardRef as ReactComponent };